export const eventImages = {
    'Bloqueio do Lago': '/images/events/image1.png',
    'Divisão do Poder de Pesca': '/images/events/image8.png',
    'Sem Descanso': '/images/events/image9.png',
    'Redução da Taxa de Captura': '/images/events/image19.png',
    'Poder de Pesca Extra': '/images/events/image5.png',
    'Aumento na Taxa de Captura': '/images/events/image9.png',
    'Mais Ouro': '/images/events/image4.png',
    'Cardume Lendário no Rio': '/images/events/image3.png',
    'Aumento de Preço das Iscas': '/images/events/image2.png',
    'Aumento de Preço das Varas': '/images/events/image2.png',
    'Aumento de Preço dos Barcos': '/images/events/image6.png',
    'Mudança de Estação': '/images/events/image10.png',
    // O evento do catálogo tem o sufixo da estação no nome; sem esta chave ele caía no fallback.
    'Mudança de Estação: Verão': '/images/events/image10.png',
    'Bloqueio do Mar Aberto': '/images/events/image8.png',
    'Divisão do Poder de Pesca no Pier': '/images/events/image8.png',
    'Mais Taxa de Captura': '/images/events/image19.png',
    'Cardume Especial na Praia': '/images/events/image11.png',
    'Estação Inverno': '/images/events/image12.png',
    'Mais Ouro no Mar Aberto': '/images/events/image13.png',
    'Redução de Preço de Iscas': '/images/events/image5.png',
    'Mais Preço para Varas': '/images/events/image2.png',
    'Evento Especial no Lago': '/images/events/image15.png',
    'Bloqueio da Praia': '/images/events/image16.png',
    'Divisão da Taxa de Captura': '/images/events/image8.png',
    'Sem Descanso no Pier': '/images/events/image9.png',
    'Melhoria no Poder de Pesca': '/images/events/image4.png',
    

    /*
     * Os sete eventos de cardume mítico — um por mapa.
     *
     * A arte deles é o PRÓPRIO bicho, e não uma cena de banco de imagens: o evento existe para
     * anunciar que aquele mítico está no mapa, então mostrar ele é o mais informativo que dá.
     * Os sprites já estão em /images/fishes/, com fundo transparente.
     *
     * Os três primeiros substituem eventos antigos que foram RENOMEADOS no catálogo
     * ('Cardume Lendário no Rio', 'Cardume Especial na Praia', 'Evento Especial no Lago'): as
     * chaves velhas continuam abaixo porque um banco que ainda não rodou o seed novo tem as
     * linhas antigas, e sem elas aquele evento cairia no fallback.
     */
    'Tremor no Cais': '/images/fishes/namazu.png',
    'O Canto na Arrebentação': '/images/fishes/sereia.png',
    'A Sombra de Três Lombadas': '/images/fishes/nessie.png',
    'A Cobra de Fogo': '/images/fishes/boitata.png',
    'A Serpente que Morde o Próprio Rabo': '/images/fishes/jormungandr.png',
    'A Subida do Portão do Dragão': '/images/fishes/carpa-dragao.png',
    'O Que Ficou no Fundo': '/images/fishes/cipactli.png',


    /*
     * Os 152 eventos do jornal escritos depois do Strapi
     * (fishinggame-backend/packages/db/seeds/eventos/jornal.json).
     *
     * A cena segue o efeito e o alvo: bloqueio mostra o mapa fechado (o Pier com o
     * céu carregado, a Praia com a cerca, o Lago, o rio, o Mar Aberto na tempestade,
     * as Ilhas Cazu na neve, a Costa Dourada), preço mostra a vila e as bancas, e o
     * cardume mostra o PRÓPRIO mítico, como os sete de cima. A ordem e o agrupamento
     * são os do seed, para a comparação lado a lado ser possível.
     */
    // blockedMap
    'Pier em Obras': '/images/events/image2.png',
    'Quarentena no Pier': '/images/events/image2.png',
    'Festa do Padroeiro no Pier': '/images/events/image2.png',
    'Ressaca na Praia': '/images/events/image16.png',
    'Águas-Vivas na Praia': '/images/events/image17.png',
    'Desova de Tartarugas na Praia': '/images/events/image16.png',
    'Névoa Fechada no Lago': '/images/events/image1.png',
    'Represa Aberta no Lago': '/images/events/image15.png',
    'Algas Vermelhas no Lago': '/images/events/image1.png',
    'Cheia do Rio Amazonas': '/images/events/image3.png',
    'Piracema no Rio Amazonas': '/images/events/image3.png',
    'Banzeiro no Rio Amazonas': '/images/events/image3.png',
    'Ciclone no Mar Aberto': '/images/events/image8.png',
    'Manobra Naval no Mar Aberto': '/images/events/image8.png',
    'Nevoeiro Cerrado no Mar Aberto': '/images/events/image8.png',
    'Nuvens Rasas nas Ilhas Cazu': '/images/events/image12.png',
    'Nevasca nas Ilhas Cazu': '/images/events/image12.png',
    'Luto em Cazulandria': '/images/events/image12.png',
    'O Nevoeiro Fechou a Passagem': '/images/events/image14.png',
    'Maré Viva na Costa Dourada': '/images/events/image13.png',
    'A Luz Apagou na Costa Dourada': '/images/events/image14.png',

    // legendaryShoal
    'A Pedra que Segura o Mundo': '/images/fishes/namazu.png',
    'Água de Barro no Pier': '/images/fishes/namazu.png',
    'A Noite em que o Cais Dançou': '/images/fishes/namazu.png',
    'Escamas na Areia': '/images/fishes/sereia.png',
    'A Rede que Voltou Cantando': '/images/fishes/sereia.png',
    'Lua Cheia na Arrebentação': '/images/fishes/sereia.png',
    'O Sonar que Apitou Sozinho': '/images/fishes/nessie.png',
    'Rastro no Junco': '/images/fishes/nessie.png',
    'A Foto Desfocada': '/images/fishes/nessie.png',
    'Olhos na Margem': '/images/fishes/boitata.png',
    'A Queimada que Não Queima': '/images/fishes/boitata.png',
    'Noite Sem Vaga-Lume': '/images/fishes/boitata.png',
    'O Horizonte Mais Alto': '/images/fishes/jormungandr.png',
    'A Bússola Parada': '/images/fishes/jormungandr.png',
    'A Maré que Não Voltou': '/images/fishes/jormungandr.png',
    'Escamas de Ouro na Di Cazu': '/images/fishes/carpa-dragao.png',
    'Trovão Sem Nuvem em Cazulandria': '/images/fishes/carpa-dragao.png',
    'A Carpa que Não Desceu': '/images/fishes/carpa-dragao.png',
    'A Costa que Mastiga': '/images/fishes/cipactli.png',
    'O Pé Perdido': '/images/fishes/cipactli.png',
    'Terra Firme que Respira': '/images/fishes/cipactli.png',

    // moreFishingPower
    'Feira de Equipamentos no Pier': '/images/events/image9.png',
    'Linha Nova de Cazulandria': '/images/events/image19.png',
    'Oficina do Mestre Anzoleiro': '/images/events/image18.png',
    'Maré de Águas Claras': '/images/events/image9.png',
    'Torneio de Arremesso': '/images/events/image19.png',
    'Óleo Fino para os Molinetes': '/images/events/image18.png',
    'Vento a Favor': '/images/events/image9.png',
    'Bênção do Farol': '/images/events/image19.png',
    'Escola de Pesca Aberta': '/images/events/image18.png',
    'Anzóis de Aço Cazu': '/images/events/image9.png',
    'Lua de Pescador': '/images/events/image19.png',
    'Dia do Pescador': '/images/events/image18.png',

    // divideFishingPower
    'Frente Fria': '/images/events/image8.png',
    'Praga de Mosquitos': '/images/events/image17.png',
    'Linha Falsificada no Mercado': '/images/events/image2.png',
    'Onda de Calor': '/images/events/image8.png',
    'Águas Turvas': '/images/events/image17.png',
    'Greve dos Anzoleiros': '/images/events/image2.png',
    'Vento Contrário': '/images/events/image8.png',
    'Gaivotas Famintas': '/images/events/image17.png',
    'Neblina de Cazulandria': '/images/events/image2.png',
    'Ferrugem nos Molinetes': '/images/events/image8.png',

    // moreCatchRate
    'Cardume de Passagem': '/images/events/image19.png',
    'Época de Engorda': '/images/events/image11.png',
    'Plâncton em Flor': '/images/events/image3.png',
    'Revoada ao Pôr do Sol': '/images/events/image19.png',
    'Isca Secreta da Guilda': '/images/events/image11.png',
    'Enchente Perfeita': '/images/events/image3.png',
    'Estiagem no Interior': '/images/events/image19.png',
    'Safra de Cazulandria': '/images/events/image11.png',
    'Chuva Fina de Dois Dias': '/images/events/image3.png',
    'Noite de Peixe Elétrico': '/images/events/image19.png',
    'Fim do Defeso': '/images/events/image11.png',
    'Cardume Perdido do Nevoeiro': '/images/events/image3.png',

    // divideCatchRate
    'Pesca Predatória': '/images/events/image8.png',
    'Água Fria Demais': '/images/events/image17.png',
    'Barulho de Dragagem': '/images/events/image1.png',
    'Golfinhos em Caçada': '/images/events/image8.png',
    'Vazamento de Óleo': '/images/events/image17.png',
    'Lua Cheia Clara': '/images/events/image1.png',
    'Cardume em Migração': '/images/events/image8.png',
    'Isca Estragada': '/images/events/image17.png',
    'Inverno Rigoroso': '/images/events/image1.png',
    'Sombra no Fundo': '/images/events/image8.png',

    // moreGolds
    'Feira de Frutos do Mar': '/images/events/image20.png',
    'Compradores de Cazulandria': '/images/events/image4.png',
    'Escassez na Capital': '/images/events/image20.png',
    'Banquete Real': '/images/events/image4.png',
    'Restaurante Novo no Pier': '/images/events/image20.png',
    'Semana do Peixe': '/images/events/image4.png',
    'Navio Mercante Ancorado': '/images/events/image20.png',
    'Concurso de Culinária': '/images/events/image4.png',
    'Exportação Liberada': '/images/events/image20.png',
    'Peixe Escasso no Continente': '/images/events/image4.png',

    // lessGold
    'Mercado Saturado': '/images/events/image20.png',
    'Boato de Peixe Contaminado': '/images/events/image4.png',
    'Imposto sobre a Pesca': '/images/events/image2.png',
    'Festa da Carne Assada': '/images/events/image20.png',
    'Compradores em Greve': '/images/events/image4.png',
    'Gelo em Falta': '/images/events/image2.png',
    'Moeda Desvalorizada': '/images/events/image20.png',
    'Estrada Interditada': '/images/events/image4.png',
    'Feira Cancelada': '/images/events/image2.png',
    'Concorrência de Cazulandria': '/images/events/image20.png',

    // moreExperience
    'Semana da Ciência': '/images/events/image18.png',
    'Mestre Pescador em Visita': '/images/events/image9.png',
    'Livro de Registros Aberto': '/images/events/image18.png',
    'Peixe Esperto': '/images/events/image9.png',
    'Torneio de Aprendizes': '/images/events/image18.png',
    'Diário de Bordo Coletivo': '/images/events/image9.png',
    'Instrutores de Cazulandria': '/images/events/image18.png',
    'Noite de Histórias no Pier': '/images/events/image9.png',
    'Concurso de Fotografia': '/images/events/image18.png',
    'Almanaque do Pescador': '/images/events/image9.png',

    // morePricesBait
    'Minhoca em Falta': '/images/events/image20.png',
    'Isca Importada de Cazulandria': '/images/events/image20.png',
    'Taxa do Porto sobre Iscas': '/images/events/image20.png',
    'Corrida por Iscas': '/images/events/image20.png',
    'Camarão Escasso': '/images/events/image20.png',
    'Loja de Iscas em Reforma': '/images/events/image20.png',
    'Queima de Estoque de Iscas': '/images/events/image4.png',
    'Safra Recorde de Minhocas': '/images/events/image4.png',
    'Cooperativa de Iscas': '/images/events/image4.png',
    'Feira de Iscas Artesanais': '/images/events/image4.png',

    // morePricesRod
    'Bambu em Falta': '/images/events/image5.png',
    'Varas de Grife': '/images/events/image5.png',
    'Imposto sobre Equipamentos': '/images/events/image5.png',
    'Incêndio na Fábrica de Varas': '/images/events/image5.png',
    'Resina Cara': '/images/events/image5.png',
    'Liquidação de Varas': '/images/events/image5.png',
    'Artesão de Varas Itinerante': '/images/events/image5.png',
    'Subsídio da Guilda': '/images/events/image5.png',
    'Fábrica Nova no Continente': '/images/events/image5.png',

    // morePricesBoat
    'Madeira de Lei Escassa': '/images/events/image6.png',
    'Estaleiro em Greve': '/images/events/image13.png',
    'Motores Retidos na Alfândega': '/images/events/image6.png',
    'Frota Perdida na Tempestade': '/images/events/image13.png',
    'Lona e Corda pela Hora': '/images/events/image6.png',
    'Leilão de Barcos Apreendidos': '/images/events/image14.png',
    'Cascos de Madeira de Nuvem': '/images/events/image6.png',
    'Fim de Temporada no Estaleiro': '/images/events/image14.png',
    'Subsídio Naval': '/images/events/image6.png',

    // noRest
    'Vigília Geral': '/images/events/image15.png',
    'Inspeção das Casas': '/images/events/image5.png',
    'Vigília da Cheia': '/images/events/image15.png',
    'Noite dos Tambores': '/images/events/image5.png',
    'Cupim nas Casas': '/images/events/image15.png',
    'Assembleia da Guilda': '/images/events/image5.png',

    // station
    'Mudança de Estação: Primavera': '/images/events/image10.png',
    'Mudança de Estação: Outono': '/images/events/image15.png',

    // Default fallback image
    'default': '/default-item.svg'
  };
  
  export const getItemImage = (itemName) => {
    return eventImages[itemName] || eventImages.default;
  };
  